import { useParams } from 'react-router-dom';

export interface IAppParams {
  account: string;
  peer: string;
  block: string;
  transaction: string;
  code: string;
}

export const useAppParams = () => {
  const params = useParams<IAppParams>();
  return params;
};
